import * as yup from 'yup'

/**
 * Reusable email validation schema for forms
 */
export const emailValidation = yup
  .string()
  .trim()
  .email('Dies ist keine valide E-Mail-Adresse')
  .required('Dies ist ein Pflichtfeld.')
  .test(
    'is-valid-email',
    'Dies ist keine valide E-Mail-Adresse',
    (value) => {
      if (!value) return false
      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
    }
  )

/**
 * Reusable privacy checkbox validation schema for forms
 */
export const privacyValidation = yup
  .boolean()
  .oneOf(
    [true],
    'Bitte lese und akzeptiere unsere Datenschutzerklärung um fortzufahren.'
  )
